<template>
  <div class="c-unit-header">
    <div v-if="title">
      <div class="c-unit-header__wrapper">
        <div v-if="cover"
          class="c-unit-header__col">
          <picture v-if="cover"
            class="c-unit-header__picture">
            <img :src="cover.header"
              class="c-unit-header__image" />
          </picture>
        </div>

        <div class="c-unit-header__col">
          <VHeading header="h1"
            class="c-unit-header__title">
            <span v-if="index" class="c-unit-header__title-index">{{ index }}</span> {{ title }}
          </VHeading>
          <div v-if="isTeacher && duration && duration.minValue"
            class="c-unit-header__school-time">
            <ClockIcon class="c-unit-header__school-time--clock" />
            {{ duration.minValue }}{{ duration.maxValue ? ' - ' + duration.maxValue : '' }}  {{ duration.durationUnit }}
            <span v-if="duration.description" class="c-unit-header__school-time--description">
              {{ duration.description }}
            </span>
          </div>
          <div v-if="isTeacher && description" v-md-html="description"
            class="c-unit-header__desc" />
        </div>
      </div>
    </div>
    <ContentLoader v-else>
      <rect x="0" y="1.5rem" width="25%" height=".75rem"></rect>
      <rect x="0" y="2.85rem" width="20%" height=".35rem"></rect>
      <rect x="0" y="3.5rem" width="48%" height=".35rem"></rect>
      <rect x="0" y="4rem" width="48%" height=".35rem"></rect>
      <rect x="0" y="4.5rem" width="48%" height=".35rem"></rect>
      <rect x="50%" y="1rem" width="50%" height="7rem"></rect>
    </ContentLoader>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import VHeading from '@forlagshuset/v-heading'
import { ContentLoader } from 'vue-content-loader'
import ClockIcon from '@/assets/svg/ClockIcon'

export default {
  components: {
    VHeading,
    ContentLoader,
    ClockIcon
  },

  props: {
    title: String,
    video: String,
    cover: Object,
    duration: Object,
    description: String,
    index: Number
  },

  setup (props, vm) {
    const isTeacher = computed(() => vm.root.$store.getters['appConfig/isTeacher'])

    return {
      isTeacher
    }
  }
}
</script>
